import {
  popularPlaceCreateApi,
  popularPlaceDeleteApi,
  popularPlaceDetailApi,
  popularPlaceEditApi,
  popularPlaceListApi,
} from "../../core/http/httpClient";
import { makeAsyncApiCall } from "../common";
import { takeEveryFsa } from "../operations";
import { popularPlaceActions } from "./actions";

export function* popularPlaceSaga() {
  yield takeEveryFsa(
    popularPlaceActions.fetchPopularPlaces.started,
    function* (action) {
      yield* makeAsyncApiCall(
        action,
        popularPlaceActions.fetchPopularPlaces,
        popularPlaceListApi
      );
    }
  );

  yield takeEveryFsa(
    popularPlaceActions.getPopularPlaceDetails.started,
    function* (action) {
      yield* makeAsyncApiCall(
        action,
        popularPlaceActions.getPopularPlaceDetails,
        popularPlaceDetailApi
      );
    }
  );

  yield takeEveryFsa(
    popularPlaceActions.createNewPopularPlace.started,
    function* (action) {
      yield* makeAsyncApiCall(
        action,
        popularPlaceActions.createNewPopularPlace,
        popularPlaceCreateApi
      );
    }
  );

  yield takeEveryFsa(
    popularPlaceActions.updatePopularPlace.started,
    function* (action) {
      yield* makeAsyncApiCall(
        action,
        popularPlaceActions.updatePopularPlace,
        popularPlaceEditApi
      );
    }
  );

  yield takeEveryFsa(
    popularPlaceActions.deletePopularPlace.started,
    function* (action) {
      yield* makeAsyncApiCall(
        action,
        popularPlaceActions.deletePopularPlace,
        popularPlaceDeleteApi
      );
    }
  );
}
